import { IMediaFile } from 'components/Design/UploadsTab/Types'
import { multiStep } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/multiStep'
import { StepProps } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/Types'
import { isVideo } from 'components/ImagePickerModal/utils'
import { useField } from 'formik'
import { useWizardSchema } from 'components/Wizards/Wizard/WizardContext'
import { MultiStepSchema } from 'components/Wizards/schemas/Types'
import { MediaPicker } from '../../../../../MobileMediaPicker/MediaPicker'
import { AlternativeWizardButton } from './components/AlternativeWizardButton'
import { getMimeTypesForMediaTypes } from './utils'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'
import { useNativeLayouts } from 'components/Wizards/hooks/useNativeLayouts'
import { DesignChannel } from 'components/NewFileModal/Types'

interface Props extends StepProps {
  onSelect?: (file: IMediaFile) => void
  skipBackgroundRemoval?: boolean
  hideAltWizard?: boolean
  onCreateDoc?: (values: any) => Promise<void>
}

export const StartWithMedia = multiStep<Props>((props) => {
  const { onSelect, submit, onCreateDoc, hideAltWizard = false, schema: stepSchema, ...rest } = props
  const schema = useWizardSchema() as MultiStepSchema
  const altWizard = !hideAltWizard ? schema.meta.altWizard : undefined
  const AltWizardButton = altWizard ? <AlternativeWizardButton altWizard={altWizard} /> : undefined
  const { meta } = stepSchema.describe()
  const { title, supportedMediaTypes = ['image'] } = meta
  const accept = getMimeTypesForMediaTypes(supportedMediaTypes)

  const [, , { setValue: setMediaFileId }] = useField('initial_media_file_id')
  const [, , { setValue: setRemoveBackground }] = useField('initial_media_file_remove_background')
  const [, , { setValue: setSelectedImages }] = useField<string[]>('selected_images')
  const [, , { setValue: setIsVideo }] = useField<boolean>('is_video')
  const [{ value: brand_kit_id }] = useField('brand_kit_id')

  const nativeLayouts = useNativeLayouts(brand_kit_id)
  const nativeLayout = nativeLayouts[schema.meta.channel as DesignChannel]

  const submitMediaValues = async (file: IMediaFile, removeBackground: boolean) => {
    setMediaFileId(file.id)
    setRemoveBackground(removeBackground)
    setSelectedImages([file.source_url])
    if (isVideo({ url: file.source_url, type: file.mime_type })) {
      setIsVideo(true)
    }

    onSelect?.(file)

    submit()
  }

  return (
    <MobileWizard.Content padding={'10px 0 0 0'}>
      {title && (
        <MobileWizard.Section padding={'0 15px'}>
          <MobileWizard.Title>{title}</MobileWizard.Title>
        </MobileWizard.Section>
      )}
      <MediaPicker
        onSelect={submitMediaValues}
        altButton={AltWizardButton}
        accept={accept}
        skipBackgroundRemoval={Boolean(nativeLayout?.enabled)}
        {...rest}
      />
    </MobileWizard.Content>
  )
})
